import { render, staticRenderFns } from "./QuizNav.vue?vue&type=template&id=448f4742&scoped=true&"
import script from "./QuizNav.vue?vue&type=script&lang=ts&"
export * from "./QuizNav.vue?vue&type=script&lang=ts&"
import style0 from "./QuizNav.vue?vue&type=style&index=0&id=448f4742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448f4742",
  null
  
)

export default component.exports